import compose from 'lodash/fp/compose';
import omit from 'lodash/omit';

import api from '../REST/api';
import { removeUnchangedValues } from '../utils/remove-unchanged-values';
import { replaceNestedWithId } from '../utils/replace-nested-with-id';

export function transformForRendering(merchant) {
  const transformedMerchant = merchant;

  if (merchant.pc) transformedMerchant.pcSalesUnit = merchant.pc.salesUnit;
  return compose([
    mer => replaceNestedWithId(mer, 'pc'),
    mer => replaceNestedWithId(mer, 'invoiceBillingEntity'),
  ])(transformedMerchant);
}

export function getTransformedMerchant(arg) {
  return api
    .getZMSAMMerchant(arg)
    .then(merchant => transformForRendering(merchant || {}));
}

function getFieldsToRemove() {
  const fieldsToRemove = ['merchantId', 'salesUnit', 'pcSalesUnit'];
  return fieldsToRemove;
}

export function transformForPatch(model, oldModel) {
  return compose([
    mer => removeUnchangedValues(mer, oldModel),
    mer => omit(mer, getFieldsToRemove()),
  ])(model);
}
